<sim-basic-material-dialog (closeClicked)="close()" [finished]="finished" [matDialogData]="data" [rect]="rect">
	<div dialogContent>
		<div class="modal-header">
			<button type="button" class="close" (click)="cancel()">×</button>
			<h4 class="modal-title"><i class="fas fa-image"></i> {{ data.media.name }}</h4>
		</div>
		<div class="modal-body" style="color: black !important">
			<p>
				<img src="{{ mediaUrl }}" alt="{{ data.media.name }}" />
			</p>
		</div>
	</div>
	<ng-container actions>
		<sim-button
			(onClick)="cancel()"
			[color]="'primary'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.MEDIA_DIALOG_CLOSE"
		/>
	</ng-container>
</sim-basic-material-dialog>
